import { useAuthentication } from '@/hooks/useAuthentication';
import { useQuery } from '@apollo/client';
import {
  QUERY_COMPLETED_TASK,
  DailyTaskHasBeenCompletedQuery,
  DailyTaskHasBeenCompletedQueryVariables,
  GENERATED,
} from '@edwin-group/cj-graphql';

export const useCompletedTask = ({ id, type }: { id?: string | null; type: GENERATED.Enum_Completedtask_Type }) => {
  const { authentication } = useAuthentication();

  const inputData = {
    day: new Date().toISOString().split('T')[0],
    type,
    relationID: parseInt(id || '0'),
    staffId: authentication?.user?.documentId || '',
  };

  const { data } = useQuery<DailyTaskHasBeenCompletedQuery, DailyTaskHasBeenCompletedQueryVariables>(
    QUERY_COMPLETED_TASK,
    {
      variables: {
        ...inputData,
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  const isCompleted = (data?.completedTasks?.data?.length || 0) > 0;

  return { isCompleted };
};
